import React, { useRef, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import * as Yup from 'yup';

import { MdLightMode, MdDarkMode } from 'react-icons/md';
import logotipo from '../../../../assets/logo.svg';
import MarcaDAgua from '../../../../assets/marca-dagua-assiste.svg';

import { useTheme } from '../../../../config/themeContext';
import { signInRequest } from '../../../../store/modules/auth/actions';

import history from '../../../../services/history';

import { AppError } from '../../../../errors/AppError';

import { Form } from '../../../../components/Form';
import Input from '../../../../components/Form/Input';

import {
  Container,
  LoginCard,
  BrandLogo,
  LoginHeader,
  LoginActions,
  Footer,
  ButtonTheme,
} from './styles';

const schema = Yup.object().shape({
  login: Yup.string().required('O campo "login" é obrigatório!'),
  password: Yup.string().required('O campo "senha" é obrigatório!'),
});

function MobileUsuarioLogin() {
  const formRef = useRef(null);
  const loading = useSelector((state) => state.loading);
  const dispatch = useDispatch();

  const location = useLocation();

  const { theme, toggleTheme } = useTheme();

  const handleConfirmar = useCallback(
    async (data) => {
      try {
        await schema.validate(data, {
          abortEarly: false,
        });

        const paramQuery = new URLSearchParams(location.search);
        const { return_to: returnTo = '/catalogo.partes' } = Object.fromEntries(
          paramQuery
        );

        const { login, password } = data;

        dispatch(signInRequest(login, password, returnTo));
      } catch (err) {
        AppError(err, formRef);
      }
    },
    [dispatch, location]
  );

  const handleRecuperaAcesso = useCallback(() => {
    history.push('/recupera-acesso');
  }, []);

  return (
    <Container>
      {/* <ButtonTheme
        type="button"
        onClick={toggleTheme}
        aria-label="Alternar tema"
      >
        {theme.mode === 'light' ? (
          <MdLightMode size={20} />
        ) : (
          <MdDarkMode size={20} />
        )}
      </ButtonTheme> */}

      <LoginCard>
        <BrandLogo>
          <img src={logotipo} alt="Assiste" />
        </BrandLogo>

        <Form
          schema={schema}
          ref={formRef}
          onSubmit={handleConfirmar}
          autoComplete="off"
        >
          <LoginHeader>
            <span>Acesso restrito</span>
            <h1>Bem-vindo</h1>
            <p>Informe suas credenciais para acessar a plataforma.</p>
          </LoginHeader>

          <Input
            id="login"
            name="login"
            label="Login"
            type="text"
            placeholder="Digite seu login"
            autoComplete="username"
          />

          <Input
            id="password"
            name="password"
            label="Senha"
            type="password"
            placeholder="Digite sua senha"
            autoComplete="current-password"
          />

          <LoginActions>
            <button
              id="btn-forgot"
              type="button"
              onClick={handleRecuperaAcesso}
            >
              Esqueceu a senha?
            </button>
          </LoginActions>

          <button id="btn-submit" type="submit" disabled={loading}>
            {loading ? 'Validando acesso...' : 'Entrar'}
          </button>
        </Form>
      </LoginCard>

      <Footer>
        <a
          href="http://assiste.com.br/"
          target="_blank"
          rel="noopener noreferrer"
          title={`Assiste - CDI - v${process.env.REACT_APP_VERSION}`}
        >
          <img src={MarcaDAgua} alt="logotipo" />
        </a>
      </Footer>
    </Container>
  );
}

export { MobileUsuarioLogin };
